
import axios from "axios";

const BASE_URL = 'https://api.goexia.com/api';

const refreshAuthToken = async () => {
    const refreshToken = sessionStorage.getItem("refreshToken");

    try {
        const response = await axios.post(`${BASE_URL}/refresh-token`, { refreshToken });
        const newToken = response.data.token;
        // const refreshToken = response.data.refreshToken;

        if (newToken) {
            sessionStorage.setItem("authToken", newToken); // Update the token
        }

        return newToken;
    } catch (error) {
        console.error("Token refresh failed:", error.response?.data || error.message);
        return null;
    }
};


const getLoggedinUser = () => {
    const user = sessionStorage.getItem("user");
    if (!user) {
      return null;
    } else {
      return JSON.parse(user);
    }
  };

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
    // console.log('setAuthorizationToken', token);
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    // console.log('setAuthorizationToken', axios.defaults.headers.common["Authorization"]);

  };

const getAuthToken = () => {
    const authToken = sessionStorage.getItem("authToken");
    // console.log('authToken', authToken);
    if (!authToken) {
      return null;
    } else {
      return authToken;
    }
  };


  export { refreshAuthToken, getLoggedinUser, getAuthToken, setAuthorization };